import { getPatientEncountersById, getPatientMasterData, getPayerActivities, downloadSessionNotesDocuments } from '../../actions/PatientActions';
import { alertConfirmation, base64Decode, showFormatedDate, showFormattedTime } from '../../../../actions/utilAction';
import Alert from 'react-s-alert';
import classNames from 'classnames';
import { CommonButton } from '../../../../components/buttons';
import { connect } from 'react-redux';
import PatientInfo from '../../patient_info';
import React from 'react';
import PaginatorCustom from '../../../../components/paginationCustom';
import SortingCustom from '../../../../components/SortingCustom';
import moment from 'moment';
import { change, Field, reduxForm, reset } from 'redux-form';
import { renderAutoCompleteSingleSelect, renderCheckBox, renderDateField, renderTextField } from '../../../../components/reduxFields';
import GlobalVariables, { resetFiltersAndSorting } from '../../../../actions/utilAction';
import { RaisedButton } from 'material-ui';


const stylescss = {
  checkbox: {
      marginBottom: 16,
  },
};

class Documents extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      appointmentId: null,
      encounterId: null,
      // allergies: [],
      includedData: [],
      allergyData: null,
      patientid: props.match.params.id ? base64Decode(props.match.params.id) : null,
      allergyId: null,
      // meta_data: null,
      AppointmentType: null,
      StaffName: null,
      Status: null,      
      FromDate: new Date().setDate(new Date().getDate() - 7),
      ToDate: new Date(),
      StatusTypes: [{ id: 1, value: 'Pending' }, { id: 2, value: 'Rendered' }],
      selectedAppointmentIds: [],
    };

    this.filter = {
      sortColumn: 'id',
      sortOrder: 'desc',
      Status: '',
    };
    this.handleBack = this.handleBack.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleSearchEncounterDetails = this.handleSearchEncounterDetails.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
  }
  loadData(pageNumber) {
    let searchObj = {
      sort_fields: this.filter.sortColumn ? this.filter.sortColumn : 'id',
      sort_order: this.filter.sortOrder ? this.filter.sortOrder : 'desc',
      filters: { patientid: this.state.patientid },
      contain_filters: { appointmentType: this.state.AppointmentType ? this.state.AppointmentType : null,
        staffName: this.state.StaffName ? this.state.StaffName : '',
        status: this.state.Status ? this.state.Status : '',      
        fromDate: this.state.FromDate ? moment(this.state.FromDate).format('YYYY-MM-DD') : new Date(),
        toDate: this.state.ToDate ? moment(this.state.ToDate).format('YYYY-MM-DD') : new Date(),
        actionName: "SessionNoteDocuments",
      },
      pageNumber: pageNumber ? pageNumber : 1,
      pageSize: GlobalVariables.PageSize,
      
    };

    this.props.getPatientEncountersById(searchObj);
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sortColumn = col_name;
      this.filter.sortOrder = col_order;
      this.loadData();
    }
  }

  componentWillMount() {
    let masterData = {
      'masterdata': 'appointmentType',
    };
    this.props.getPatientMasterData(masterData);
    this.loadData();
  }

  handleBack = () => {
    Alert.closeAll();
    this.setState({ open: false, appointmentId: null, encounterId: null });
    this.loadData();
  };

 
  handleAlertClick=(event, encounterId) => {
    Alert.closeAll();
  };

  handleDeleteClick=(event, obj) => {
    alertConfirmation('Are you sure you want to delete encounter ?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: obj.id,
      },
    });
  };

  checkAllAppointments = (e) => {
    let isAllAppointmentChecked = e.target.checked;
    let appointmentData = this.props.encounters.data !== undefined && this.props.encounters.data;
    let selectedAppointmentIds = [];
    
    appointmentData.forEach((obj, appointmentIndex) => {
        let appointmentIdCheck = `Appointments[${appointmentIndex}].Chk`;
        if(obj && isAllAppointmentChecked) {              
            selectedAppointmentIds.push(obj.patientAppointmentId);
            this.props.dispatch(change('DocumentsListing', appointmentIdCheck, true));
        } 
        else
        {
          this.props.dispatch(change('DocumentsListing', appointmentIdCheck, false));
        }
    });
   
    this.setState({ selectedAppointmentIds : selectedAppointmentIds });
  }

  checkAppointments = (e, index, data) => {
    let selectedAppointmentIds = this.state.selectedAppointmentIds;    
    let isAppointmentChecked = e.target.checked;
    if (isAppointmentChecked) {
          selectedAppointmentIds.push(data.patientAppointmentId);
    } 
    else {      
        index = selectedAppointmentIds.findIndex((value) => value === data.patientAppointmentId);
        if (index >= 0) {
          selectedAppointmentIds.splice(index, 1);
        }      
    }
    this.setState({ selectedAppointmentIds: selectedAppointmentIds });
  }


  handleReset = () => {
    Alert.closeAll();
    this.props.dispatch(reset('DocumentsListing'));
    resetFiltersAndSorting(this.filter, 'id', true);
    // this.filter.Status = 'Pending';
    this.setState({ AppointmentType: null,
      StaffName: null,
      Status: null,
      FromDate: new Date().setDate(new Date().getDate() - 7),
      ToDate: new Date(),
      selectedAppointmentIds: []
    }, () => {
      this.props.dispatch(change('DocumentsListing', 'chkAppointment', false));
      let appointmentData = this.props.encounters.data !== undefined && this.props.encounters.data;
      appointmentData.forEach((obj, appointmentIndex) => {
        let appointmentIdCheck = `Appointments[${appointmentIndex}].Chk`;
        this.props.dispatch(change('DocumentsListing', appointmentIdCheck, false));
      });
      this.loadData();
    });
  };

  handleSearchEncounterDetails(event) {
  // event.preventDefault();
  // console.log('event............',event);
    // if (!Object.keys(event).length) {
    //   return false;
    // }
    this.setState({
      AppointmentType: event.AppointmentType ? event.AppointmentType : null,
      StaffName: event.StaffName ? event.StaffName : null,
      Status: this.state.Status || '',   
    }, () => {
      this.loadData();
    });    
  }


  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  }

handleNewRequest = (input, selectedRecord) => {
  input.onChange(selectedRecord.value);
  this.setState({ [input.name]: selectedRecord.value || null });  
}

handleNewRequestStatus = (input, selectedRecord) => {
  // console.log('selectedRecord.......',selectedRecord.label);
  input.onChange(selectedRecord.value);
  // this.filter.Status = selectedRecord.label;
  this.setState({ Status: selectedRecord.label });
}


  handleDownloadDocumentsClick = (event) => {
    let searchObj = {
      sort_fields: this.filter.sortColumn ? this.filter.sortColumn : 'id',
      sort_order: this.filter.sortOrder ? this.filter.sortOrder : 'desc',
      filters: { patientid: this.state.patientid },
      contain_filters: { appointmentType: this.state.AppointmentType ? this.state.AppointmentType : null,
        staffName: this.state.StaffName ? this.state.StaffName : '',
        status: this.state.Status ? this.state.Status : '',
        fromDate: this.state.FromDate ? moment(this.state.FromDate).format('YYYY-MM-DD') : new Date(),
        toDate: this.state.ToDate ? moment(this.state.ToDate).format('YYYY-MM-DD') : new Date(),
        actionName: "SessionNoteDocuments",
      },
      pageNumber: 1,
      pageSize: GlobalVariables.PageSize,
    };

    this.props.downloadSessionNotesDocuments(this.state.selectedAppointmentIds.toString(), "SessionNoteDocument", searchObj);
    Alert.closeAll();
  }

  handleDownloadDocuments = (event) => {
    Alert.warning('Are you sure you want to download documents for selected encounters?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleDownloadDocumentsClick,
        //id: obj.id,
      },
    });
  }

renderData() {
  if (this.props.encounters && this.props.encounters.data && this.props.encounters.data.length > 0) {
    return this.props.encounters.data.map((Obj, index) => {
      return (
        <tr key={Obj.id}>          
          <td width="5%">
              <div className="table_custom-check">
                  <Field
                      name={`Appointments[${index}].Chk`}
                      component={renderCheckBox}
                      onChange={(e) => this.checkAppointments(e, index, Obj)}
                      style={stylescss.checkbox}
                  />
              </div>
          </td>
          <td>{Obj.patientAppointmentId}</td>
          <td>{showFormatedDate(Obj.dateOfService)}{' (' + showFormattedTime(Obj.startDateTime) + ' - ' + showFormattedTime(Obj.endDateTime) + ')'}</td>
          <td>{Obj.duration}</td>
          <td>{Obj.staffName}</td>
          <td>{Obj.appointmentType}</td>
          <td className = {Obj.status === 'Pending' ? 'redfont' : Obj.status === 'Rendered' ? 'greenfont' : 'orangefont'}>{Obj.status}</td>
        </tr>
      );
    });
  } else {
    return (
      <tr>
        <td colSpan="7">
          <div className="familydl text-center no-record">No record found.</div>
        </td>
      </tr>
    );
  }
};

renderEncounterListingData() {
  const { handleSubmit } = this.props;
  const tableClass = classNames({
    'table': true,
    'table-striped': this.props.condensed,
    'table-bordered': this.props.bordered,
    'table-hover': true,
    'table-condensed': this.props.condensed,
    'customtable': true,
  });
  return (
    <div className="readmin-panel">
      <div className="panel-body">
        <form className="readmin-form custom_form" onSubmit={ handleSubmit(this.handleSearchEncounterDetails)}>
          <div className="row">
            <div className="col-sm-4"></div>
          </div>
          <div className="row">
            <div className="col-sm-4 col-md-4 mt-35">
              <Field
                name="AppointmentType"
                label="Appointment Type"
                options={this.props.masterActivityType}
                handleNewRequest={this.handleNewRequest}
                component={renderAutoCompleteSingleSelect}
              />
            </div>
            <div className="col-sm-4 col-md-4">
              <Field name="StaffName"
                floatingLabelText="Staff Name"
                maxLength="50"
                //onChange={this.handleSearchChange}
                component={renderTextField} />
            </div>
            <div className="col-sm-4 col-md-4 mt-35">
              <Field
                name="Status"
                label="Status"
                options={this.state.StatusTypes}
                handleNewRequest={this.handleNewRequestStatus}
                component={renderAutoCompleteSingleSelect}/>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 col-md-6">
              <Field name="FromDate"
                placeholder="From Date"
                locale="en-US"
                selected={this.state.FromDate}
                onDateChange={this.onDateChange}
                openToYearSelection = {true}
                component={renderDateField} />
            </div>
            <div className="col-sm-6 col-md-6">
              <Field name="ToDate"
                placeholder="To Date"
                locale="en-US"
                selected={this.state.ToDate}
                onDateChange={this.onDateChange}
                openToYearSelection = {true}
                component={renderDateField} />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 btn_rt reset-btn">
              {this.props.dpwnloadPermission ?
                    <RaisedButton className={this.state.selectedAppointmentIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"} disabled={this.state.selectedAppointmentIds.length > 0 ? false : true} onTouchTap={(e) => this.handleDownloadDocuments(e)} >Download Document(s)</RaisedButton>
                    : null}
              <CommonButton className="grey_btn ml_15" type="Submit" primary={true} onTouchTap={this.handleSearchReadyToBillClaim} label = 'Filter'/>
              <CommonButton className="grey_btn ml_15" onTouchTap={this.handleReset} label = 'Reset'/>
            </div>
          </div>
        </form>
        <div className="row">
          <div className="col-sm-12 mt-20">
            <div>
              <div className="table-responsive">
                <table className={tableClass}>
                  {this.props.encounters && this.props.encounters.data && this.props.encounters.data.length ?
                    <thead>
                      <tr>
                        <th width="8%">
                            <div className="table_custom-check">
                                <Field
                                    name='chkAppointment'
                                    component={renderCheckBox}
                                    onChange={(e) => this.checkAllAppointments(e)}
                                    style={stylescss.checkbox}
                                />
                                <span>&nbsp;</span>
                            </div>
                        </th>
                        <th width="10%"><SortingCustom setSortColumn={this.setSortColumn} columnName='patientAppointmentId' displayName='Appoint.#'/></th>
                        <th width="24.28%"><SortingCustom setSortColumn={this.setSortColumn} columnName='dateOfService' displayName='Date Of Service'/></th>
                        <th width="10.28%">Duration</th>
                        <th width="14.28%"><SortingCustom setSortColumn={this.setSortColumn} columnName='staffName' displayName='Practitioner'/></th>
                        <th width="16%"><SortingCustom setSortColumn={this.setSortColumn} columnName='appointmentType' displayName='Appointment Type'/></th>
                        <th width="10%"><SortingCustom setSortColumn={this.setSortColumn} columnName='status' displayName='Status'/></th>
                        {/* <th width="10%">Notes</th> */}
                        
                      </tr>
                    </thead>
                    :
                    <thead>
                      <tr>
                        <th width="8%"></th>
                        <th width="10%">Appoint.#</th>
                        <th width="24.28%">Date Of Service</th>
                        <th width="10.28%">Duration</th>
                        <th width="14.28%">Practitioner</th>
                        <th width="16%">Appointment Type</th>
                        <th width="10%">Status</th>
                        {/* <th width="10%">Notes</th> */}
                       
                      </tr>
                    </thead> }
                  <tbody>
                    {this.renderData()}
                  </tbody>
                </table>
              </div>
              {this.props.encounters && this.props.encounters.data && this.props.encounters.data.length ?
                <PaginatorCustom data={this.props.encounters.meta} handlePageChange={(pageNumber) => this.loadData(pageNumber)} />
                : null }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

render() {
  return (
    <div>
      <h2 className="page_title">Client Documents</h2>
      <PatientInfo patientId={this.state.patientid} />
      <div className="clearfix"></div>
      {this.renderEncounterListingData()}
    </div>
  );
}
}

Documents = reduxForm({
  form: 'DocumentsListing',
})(Documents);


function mapStateToProps(state) {
  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'CLIENT');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'SESSION_NOTE_DOCUMENTS_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }
  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission
  let dpwnloadPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SESSION_NOTE_DOCUMENTS_LIST_DOWNLOAD')[0].permission : false;
  // End For Role Permission
  // console.log('state.patient.encounters............',state.patient.encounters);
  return {
    encounters: state.patient.encounters,
    allergyData: state.patient.allergyData,
    patientMasterData: state.patient.patientMasterData,
    masterActivityType: state.patient.patientMasterData ? state.patient.patientMasterData.appointmentType : [],
    dpwnloadPermission: dpwnloadPermission,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}
export default connect(mapStateToProps, { getPatientMasterData, getPatientEncountersById, getPayerActivities, downloadSessionNotesDocuments })(Documents);



// WEBPACK FOOTER //
// ./src/modules/patients/components/SessionNoteDocuments/index.js